const PRIORITY = [
  {
    value: 'URGENTE_IMPORTANTE',
    key: 'urgenteImportante',
    name: 'Urgente e Importante',
  },
  {
    value: 'NAO_URGENTE_IMPORTANTE',
    key: 'naoUrgenteImportante',
    name: 'Não Urgente e Importante',
  },
  {
    value: 'URGENTE_NAO_IMPORTANTE',
    key: 'urgenteNaoImportante',
    name: 'Urgente e Não Importante',
  },
  {
    value: 'NAO_URGENTE_NAO_IMPORTANTE',
    key: 'naoUrgenteNaoImportante',
    name: 'Não Urgente e Não Importante',
  },
]

export { PRIORITY }
